import React from 'react';
import { authenticationRoute } from '@/modules/core/auth/route';
import { createRoute } from '@tanstack/react-router';

export const resetPasswordRoute = createRoute({
  getParentRoute: () => authenticationRoute,
  path: 'reset-password',
  component: React.lazy(async () => await import('@/containers/ResetPasswordContainer')),
  wrapInSuspense: true,
});
